import { Language, Advert } from '@/interfaces/common';

export type Info = {
  title: string;
  description: string;
};

export type InfoByLang = Record<Language, Info>;

export enum Page {
  AllAds = 'AllAds',
  Profile = 'Profile',
  AnnonceLight = 'AnnonceLight',
  Login = 'Login',
  Register = 'Register',
  Eroguide = 'Eroguide',
  GuideAboutEscort = 'GuideAboutEscort',
  MassageEscort = 'MassageEscort',
  SexAnnoncer = 'SexAnnoncer',
  EscortPiger = 'EscortPiger',
}

export function makeAdvertPageInfo(ad: Advert): InfoByLang {
  const kind = ad.type?.name?.toLowerCase();
  const place = ad.zone?.name || ad.area?.name || ad.division?.name;

  return {
    da: {
      title: `${ad.name} | ${kind} i ${place}`,
      description: `${ad.name} er en ${ad.category?.name} på ${ad.age} i ${place} der tilbyder ${kind}.`,
    },
    en: {
      title: `${ad.name} | ${kind} in ${place}`,
      description: `${ad.name} is a ${ad.age}-year-old ${ad.category?.name} in ${place} who offers ${kind} services.`,
    },
  };
}

export const all: Record<Page, InfoByLang> = {
  [Page.AllAds]: {
    da: {
      title: 'Alle Sex Annoncer – Escort, Massage & Diskrete Tjenester',
      description:
        'Udforsk alle sex annoncer i Danmark. Find escort, massage og diskrete tjenester i København, Odense, Aarhus, Aalborg og flere byer.',
    },
    en: {
      title: 'All Sex Ads – Escort, Massage & Discreet Services in Denmark',
      description:
        'Browse all sex ads in Denmark. Discover escort, massage, and discreet listings in Copenhagen, Odense, Aarhus, Aalborg & more.',
    },
  },
  [Page.Profile]: {
    da: {
      title: 'Min Konto – Administrer Annoncer & Favoritter',
      description:
        'Se og rediger dine escort annoncer, beskeder og favoritter på din myescort.dk-profil. Fuld kontrol over din escortprofil.',
    },
    en: {
      title: 'My Account – Manage Ads & Favorites',
      description:
        'View and edit your escort ads, messages, and favorites on your myescort.dk account. Full control over your escort profile.',
    },
  },
  [Page.AnnonceLight]: {
    da: {
      title: 'Hvad er Annoncelight.dk? Fuld Anmeldelse & Annoncer i Din By',
      description:
        'Oplev Annoncelight.dk – Danmarks store annonceportal for erotiske tjenester og ejer af eriguide.dk. Læs hvordan det fungerer, hvad du kan forvente, og se troværdige alternativer som myescort.dk.',
    },
    en: {
      title: 'What Is Annoncelight.dk? Full Review & Local Escort Listings',
      description:
        'Discover Annoncelight.dk – Denmark’s major ad site for erotic services and the owner of eroguide.dk. Learn how it works, what to expect, and explore trusted alternatives like myescort.dk.',
    },
  },
  [Page.Login]: {
    da: {
      title: 'Log Ind på myescort.dk – Adgang til Din Escortprofil',
      description:
        'Log ind på din myescort.dk-konto for at se annoncer, sende beskeder og styre dine favoritter.',
    },
    en: {
      title: 'Login to myescort.dk – Access Your Escort Profile',
      description:
        'Log in to your myescort.dk account to view listings, message providers, and manage your profile and favorites.',
    },
  },
  [Page.Register]: {
    da: {
      title: 'Opret Bruger på myescort.dk – Din Escortportal',
      description:
        'Tilmeld dig myescort.dk gratis og få adgang til escort annoncer, kontaktfunktioner og dine personlige favoritter',
    },
    en: {
      title: 'Register at myescort.dk – Your Escort Platform',
      description:
        'Sign up for free on myescort.dk to access escort ads, contact providers, and manage favorites.',
    },
  },
  [Page.Eroguide]: {
    da: {
      title: 'Eroguide: Den Ultimative Guide til eroguide.dk i Danmark',
      description:
        'Lær alt om eroguide.dk – Danmarks førende erotisk anmeldelsesside. Få indblik i funktioner, brugeranmeldelser og tryghedstips.',
    },
    en: {
      title: 'Eroguide: Den Ultimative Guide til eroguide.dk i Danmark',
      description:
        'Lær alt om eroguide.dk – Danmarks førende erotisk anmeldelsesside. Få indblik i funktioner, brugeranmeldelser og tryghedstips.',
    },
  },
  [Page.GuideAboutEscort]: {
    da: {
      title: 'EscortGuide: Ultimativ Guide til Escort Piger & Byannoncer',
      description:
        'Oplev EscortGuide – Danmarks førende sted for escort piger, massage escort info og byannoncer i København, Odense, Aarhus og Aalborg.',
    },
    en: {
      title: 'EscortGuide: Ultimativ Guide til Escort Piger & Byannoncer',
      description:
        'Oplev EscortGuide – Danmarks førende sted for escort piger, massage escort info og byannoncer i København, Odense, Aarhus og Aalborg.',
    },
  },
  [Page.MassageEscort]: {
    da: {
      title: 'Massage Escort i Danmark – Guide til Massage i Danmark',
      description:
        'Oplev massage escort i Aalborg, Odense, København & Aarhus. Lær om typer, priser, booking og sikkerhed i vores informative guide.',
    },
    en: {
      title: 'Massage Escort in Denmark – Complete Guide to Massage in Denmark',
      description:
        'Discover massage escort options in Aalborg, Odense, Copenhagen & Aarhus. Learn about types, prices, booking and safety in our complete guide.',
    },
  },
  [Page.SexAnnoncer]: {
    da: {
      title: 'Sex Annoncer i Danmark – Platforme og Sikker Brug',
      description:
        'Find ud af hvordan du bruger sex annoncer platforme i Danmark sikkert og effektivt. Læs om escortguide, priser, tips og gode råd.',
    },
    en: {
      title: 'Sex Annoncer i Danmark – Platforme og Sikker Brug',
      description:
        'Find ud af hvordan du bruger sex annoncer platforme i Danmark sikkert og effektivt. Læs om escortguide, priser, tips og gode råd.',
    },
  },
  [Page.EscortPiger]: {
    da: {
      title: 'Sex Annoncer i Danmark – Platforme og Sikker Brug',
      description:
        'Find ud af hvordan du bruger sex annoncer platforme i Danmark sikkert og effektivt. Læs om escortguide, priser, tips og gode råd.',
    },
    en: {
      title: 'Sex Annoncer i Danmark – Platforme og Sikker Brug',
      description:
        'Find ud af hvordan du bruger sex annoncer platforme i Danmark sikkert og effektivt. Læs om escortguide, priser, tips og gode råd.',
    },
  },
};
